import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userSlice from './slices/userSlice';
import appSlice from './slices/appSlice';

const persistConfig = {
    key: 'store',
    storage,
    whitelist: ['user', 'app'],
};

export const rootReducer = combineReducers({
    user: userSlice,
    app: appSlice
});

export const persistRootStore = persistReducer(persistConfig, rootReducer);